import { render } from "./WindChartCard.vue?vue&type=template&id=308a1d98&scoped=true"
import script from "./WindChartCard.vue?vue&type=script&lang=js"
export * from "./WindChartCard.vue?vue&type=script&lang=js"

import "./WindChartCard.vue?vue&type=style&index=0&id=308a1d98&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-308a1d98"]])

export default __exports__